
import { mapState } from 'vuex'

export default {
  inject: ['info'],
  props: {
    title: {
      type: String,
      default: ''
    },
    titlesize: {
      type: String,
      default: ''
    },
    noline: {
      type: String,
      default: ''
    },
    elementtype: {
      type: String,
      default: ''
    },
    showallway: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      isMobile: 'mobile'
    })
  },
  mounted() {
    // console.log('文字版交易商标题')
  },
  methods: {
    ALB() {
      return this.$store.state.LanguageCode == 'ar' ? 'ALB' : ''
    }
  }
}
